"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubLink = exports.SubItem = exports.Root = exports.MobileRoot = exports.MainCategory = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  gap: theme.spacing(0),
  display: 'flex',
  flexDirection: 'column',
  margin: theme.spacing(6, 12)
}));
const MobileRoot = exports.MobileRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0),
  '&:last-child': {
    marginBottom: 'unset'
  }
}));
const MainCategory = exports.MainCategory = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  fontWeight: theme.typography.fontWeightBold,
  width: '100%',
  fontSize: '1.6rem',
  textDecoration: 'none'
}));
const SubItem = exports.SubItem = (0, _mui.styled)('li')(({
  theme
}) => ({
  fontWeight: theme.typography.fontWeightRegular,
  listStyleType: 'none',
  fontSize: '1.6rem',
  margin: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(2, 0),
    '&:last-child': {
      marginBottom: theme.spacing(6)
    }
  }
}));
const SubLink = exports.SubLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
  fontSize: '1.7rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.6rem'
  }
}));
